import {
  RadiusParserPasswordState,
  RadiusParserPasswordActionTypes,
  GET_RADIUS_PARSER_PASSWORD_PENDING,
  GET_RADIUS_PARSER_PASSWORD_FULFILLED,
  GET_RADIUS_PARSER_PASSWORD_REJECTED,
  DELETE_RADIUS_PARSER_PASSWORD_FULFILLED,
  SET_RADIUS_PARSER_PASSWORD_LOADING,
  CREATE_RADIUS_PARSER_PASSWORD_PENDING,
  CREATE_RADIUS_PARSER_PASSWORD_FULFILLED,
  CREATE_RADIUS_PARSER_PASSWORD_REJECTED,
  DELETE_RADIUS_PARSER_PASSWORD_PENDING,
  DELETE_RADIUS_PARSER_PASSWORD_REJECTED,
  UPDATE_RADIUS_PARSER_PASSWORD_PENDING,
  UPDATE_RADIUS_PARSER_PASSWORD_FULFILLED,
  UPDATE_RADIUS_PARSER_PASSWORD_REJECTED,
} from './radiusParserPassword.types';

export const initialState: RadiusParserPasswordState = {
  single: undefined,
  ui: {
    isLoading: false,
    isSaving: false,
  },
};

export default function radiusParserPasswordReducer(
  state = initialState,
  action: RadiusParserPasswordActionTypes,
): RadiusParserPasswordState {
  switch (action.type) {

    case GET_RADIUS_PARSER_PASSWORD_PENDING:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: true,
        }
      };

    case GET_RADIUS_PARSER_PASSWORD_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
        ui: {
          ...state.ui,
          isLoading: false,
        }
      };

    case GET_RADIUS_PARSER_PASSWORD_REJECTED:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false,
        }
      };

    case CREATE_RADIUS_PARSER_PASSWORD_PENDING:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false,
          isSaving: true,
        }
      };
    case CREATE_RADIUS_PARSER_PASSWORD_FULFILLED:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false,
          isSaving: false,
        }
      };
    case CREATE_RADIUS_PARSER_PASSWORD_REJECTED:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false,
          isSaving: false,
        }
      };

    case DELETE_RADIUS_PARSER_PASSWORD_PENDING:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false,
          isSaving: true,
        }
      };
    case DELETE_RADIUS_PARSER_PASSWORD_FULFILLED:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false,
          isSaving: false,
        }
      };
    case DELETE_RADIUS_PARSER_PASSWORD_REJECTED:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false,
          isSaving: false,
        }
      };

    case UPDATE_RADIUS_PARSER_PASSWORD_PENDING:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false,
          isSaving: true,
        }
      };
    case UPDATE_RADIUS_PARSER_PASSWORD_FULFILLED:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false,
          isSaving: false,
        }
      };
    case UPDATE_RADIUS_PARSER_PASSWORD_REJECTED:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false,
          isSaving: false,
        }
      };

    case SET_RADIUS_PARSER_PASSWORD_LOADING:
      return {
        ...state,
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
